/**
 * Navigation chrome: the sidebar rail, the mobile tab bar, the hamburger
 * drawer and the header.
 *
 * `nav.items.<id>` is keyed by the `id` on each `NavItemDef` in `nav-config.ts`
 * rather than by the English label, so renaming a row in English never
 * orphans its translation. Section labels are keyed by section id for the
 * same reason.
 */
export const nav = {
  sections: {
    learn: "Learn",
    "my-space": "My Space",
    community: "Community",
  },
  items: {
    home: "Home",
    browse: "Browse",
    videos: "Videos",
    "random-question": "Roll & Talk",
    "my-topics": "My Topics",
    vocabulary: "My Vocabulary",
    collections: "Collections",
    notes: "Notes",
    progress: "Progress",
    "study-groups": "Study Groups",
    "ai-chat": "AI Chat",
    leaderboard: "Leaderboard",
  },
  groups: {
    myTopics: "Topics & practice",
    vocabulary: "Vocabulary",
    community: "Community",
  },
  actions: {
    expand: "Expand {{name}}",
    collapse: "Collapse {{name}}",
    expandSidebar: "Expand sidebar",
    collapseSidebar: "Collapse sidebar",
  },
  header: {
    search: "Search topics",
    searchPlaceholder: "Search topics...",
    menu: "Open menu",
    home: "Home",
  },
  avatar: {
    profile: "Profile",
    openProfile: "Open profile settings",
    myTopics: "My Topics",
    myVocabulary: "My Vocabulary",
    takeTour: "Take a tour",
    signOut: "Sign Out",
    signedOutTitle: "Signed out",
    signedOutDescription: "You have been signed out successfully.",
    /** Label over the language + theme group at the foot of the profile menu. */
    device: "This device",
    streak: {
      /** Zero is a state to do, not a number to have. */
      idle: "Start a streak today",
      active: "{{count}} day streak",
      /** The unit alone — the figure beside it is the number. No `count`. */
      dayWord: "day streak",
      openActive: "{{count}} day streak — open streak details",
      openIdle: "No active streak — open streak details",
    },
    level: "Lv. {{level}}",
    levelProgress: "Progress to the next level",
    xp: "{{count}} XP",
    theme: {
      label: "Appearance",
      light: "Light",
      dark: "Dark",
      system: "System",
      lightAria: "Light theme",
      darkAria: "Dark theme",
      systemAria: "System theme",
    },
  },
  mobile: {
    more: "More",
    tabBar: "Main navigation",
  },
  /** Landing-page header links (apps/www shell is separate). */
  landing: {
    about: "About",
    updates: "Updates",
  },
  breadcrumbHome: "Home",
} as const;
